import { render, staticRenderFns } from "./ModalProcessoRegistro.vue?vue&type=template&id=46936c1e&scoped=true"
import script from "./ModalProcessoRegistro.vue?vue&type=script&lang=js"
export * from "./ModalProcessoRegistro.vue?vue&type=script&lang=js"
import style0 from "./ModalProcessoRegistro.vue?vue&type=style&index=0&id=46936c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46936c1e",
  null
  
)

export default component.exports